import { render, staticRenderFns } from "./store-contest-statistics.vue?vue&type=template&id=72e38d38&scoped=true&"
import script from "./store-contest-statistics.vue?vue&type=script&lang=js&"
export * from "./store-contest-statistics.vue?vue&type=script&lang=js&"
import style0 from "./store-contest-statistics.vue?vue&type=style&index=0&id=72e38d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e38d38",
  null
  
)

export default component.exports